import moment from 'moment';
import momentTZ from 'moment-timezone';

export function convertToUTCDate(dueDate, startTime) {
  // dueDate = '2018-01-01' startTime = '12:00'
  const date = moment(dueDate);
  const timeComponents = startTime.split(':');
  date.hour(parseInt(timeComponents[0], 10));
  date.minute(parseInt(timeComponents[1], 10));
  if (timeComponents[2]) {
    date.second(parseInt(timeComponents[2], 10));
  } else {
    date.second(0);
  }
  return date.utc();
}

export function getLocalISODate() {
  const presentTimeStamp = new Date();
  const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
  const localISODate = new Date(presentTimeStamp - tzoffset).toISOString().split('T')[0];
  return localISODate;
}

export function convertUTCDateStringToYYYYMMDDHHMMSSFormat(utcDateStr) {
  const date = moment(utcDateStr);
  const formatString = date.format('YYYY-MM-DD HH:mm:ss');
  return formatString;
}

export function convertDateToYYYYMMDDFormat(localDate) {
  const date = moment(localDate);
  const formatString = date.format('YYYY-MM-DD');
  return formatString;
}

export function isValidDate(date) {
  const re =
    /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?(Z|[+-](?:2[0-3]|[01][0-9])(?::?(?:[0-5][0-9]))?)?$/;
  return re.test(date);
}

/**
 *
 * @param date is a date object
 * @param time is in string format e.g. 12:00
 */
export function setTimeToDate(date, time) {
  const hours = time.split(':')[0];
  const minutes = time.split(':')[1];
  const rDate = new Date(new Date(new Date(date.setHours(hours)).setMinutes(minutes)).setSeconds(0));
  return rDate;
}

/**
 *
 * @param time in HH:mm format string
 * @param timeZone
 * @returns local time in HH:mm format
 */
export function convertTimeToLocalTimeZone(time, timeZone) {
  const timeMoment = momentTZ.tz(`${moment().format('YYYY-MM-DD')} ${time}`, timeZone);
  return timeMoment.local().format('HH:mm');
}

export function convertMinutesToHHMM(minutes) {
  const timeInHHMM = `${parseInt(minutes / 60, 10).toLocaleString('en', {
    minimumIntegerDigits: 2,
  })}:${(minutes % 60).toLocaleString('en', {
    minimumIntegerDigits: 2,
  })}`;
  return timeInHHMM;
}

export function convertHHMMToMinutes(HHMMstring) {
  const [hours, minutes] = HHMMstring.split(':').map((str) => parseInt(str, 10));
  return hours * 60 + minutes;
}

export function getToastrDateText(date) {
  const formatStr = 'D MMM YYYY hh:mm a';
  if (moment.isMoment(date)) {
    return date.local().format(formatStr);
  }
  return moment(date).local().format(formatStr);
}

/**
 * convert minutes into x h y m format. e.g. - 90 minutes => 1 h 30 m and 40 minutes => 40 m
 * @param minutes
 */
export function convertMinuteToHMDisplay(minutes) {
  const hoursLeftToday = parseInt(minutes / 60, 10);
  minutes -= 60 * hoursLeftToday;
  let displayLabel = hoursLeftToday !== 0 ? `${hoursLeftToday} h` : ``;
  displayLabel += minutes !== 0 || (minutes === 0 && hoursLeftToday === 0) ? ` ${minutes} m` : ``;
  return displayLabel;
}
